import $axiosProtected from "../../../common/utils/axiosUtils";

export const createPurchaseOrder = async (payload: any) => {
    return await $axiosProtected().post(
        `/inventory/purchase-order/store`,
        payload
    );
};
